import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'accredible-form-section-component',
  templateUrl: 'form-section.component.html',
  styleUrls: ['form-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSectionComponent {
  title = input<string>();
  image = input<string>();
  description = input<string>();
  isLoading = input<boolean>(false);
}
